import { AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useAppDispatch } from ".";
import { certifyExe } from "../apis/auth";
import { close, open } from "../redux/loginLayerSlice";
import { CertifyInfo } from "../types";


const useCertify = () => {
    const dispatch = useAppDispatch();
    return useMutation<AxiosResponse, Error, CertifyInfo>(async (data) => await certifyExe(data), {
        onSuccess: (data) => {
            if ("1" === data.data.resultCode) {
                dispatch(close());
                dispatch(open("password"));
            } else {
                alert("인증 정보가 없습니다. 정보를 확인해 주세요.")
                return;
            }
        }
    });
}

export default useCertify;